export const money = (n) =>
  "$" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const round2 = (n) => Math.round(n * 100) / 100;

// "12-3456789" -> "**-***6789" - last 4 digits only, for showing an EIN in a
// rejection-detail modal without displaying the whole number.
export function maskEin(ein) {
  const digits = (ein || "").replace(/\D/g, "");
  if (digits.length < 4) return ein || "";
  return `**-***${digits.slice(-4)}`;
}

export function formatPhone(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
